<template>
    <div>
        <div v-if="currentUser === null" class="membership center">
            <div class="wrapper">
                <h2>You are not Logged In!</h2>
                <p>Login or Register today to join our events.</p>
                <router-link to="/login" class="btn green">Login</router-link>
                <span>or</span>
                <router-link to="/register" class="btn green">Register</router-link>
            </div>
        </div>
        <div v-if="currentUser !== null && !isMember" class="membership center">
            <div class="wrapper">
                <h2>You are not a Member yet!</h2>
                <p>Hi there, become a member now and join our events</p>
                <router-link to="/welcome1" class="btn green">Become a Member</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            currentUser(){
                return this.$store.state.currentUser
            },
            userProfile(){
                return this.$store.state.userProfile
            },
            isMember(){
                return this.$store.state.isMember
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Membership.vue